import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import "./App.css";
import "./Media.css";
import scissor from "./assets/scissor.png";
import deezey from "./assets/deezey.png";
import enco from "./assets/Enco.png";
import javascript from "./assets/javascript.png";
import react from "./assets/react.png";
import css from "./assets/css3.png";
import html from "./assets/html.png";
import vue from "./assets/vuejs.png";
import typescript from "./assets/typescript.png";
import vscode from "./assets/vscode.png";
import git from "./assets/git.png";
import github from "./assets/github.png";
import firebase from "./assets/firebase.png";
import man from "./assets/relaxing.png";
import twitter from "./assets/twitter.png";
import linkedin from "./assets/linkedin.png";
import githubWhite from "./assets/github-white.png";

const App = () => {
  const home = useRef(null);
  const works = useRef(null);
  const about = useRef(null);
  const contact = useRef(null);

  const scrollToSection = (elementRef) => {
    window.scrollTo({
      top: elementRef.current.offsetTop,
      behavior: "smooth",
    });
  };

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
    document.body.style.overflow = isMenuOpen ? "auto" : "hidden";
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
    document.body.style.overflow = "auto";
  };

  useEffect(() => {
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);
  return (
    <div className="main">
      <header ref={home}>
        <div className="nav-shadow">
          <nav>
            <div className="div">
              <motion.h2
                onClick={() => {
                  scrollToSection(home);
                }}
              >
                unorthodoxDev
              </motion.h2>
              <div className="burger" onClick={handleMenuToggle}>
                <div className={`line ${isMenuOpen ? "open" : ""}`}></div>
                <div className={`line ${isMenuOpen ? "open" : ""}`}></div>
                <div className={`line ${isMenuOpen ? "open" : ""}`}></div>
              </div>
              <div className={`nav-links ${isMenuOpen ? "open" : ""}`}>
                <motion.p
                  initial={{ y: -30, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.1, type: "spring" }}
                  viewport={{ once: true }}
                  onClick={() => {
                    handleLinkClick();
                    scrollToSection(works);
                  }}
                >
                  Works
                </motion.p>
                <motion.p
                  initial={{ y: -30, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.25, type: "spring" }}
                  viewport={{ once: true }}
                  onClick={() => {
                    handleLinkClick();
                    scrollToSection(about);
                  }}
                >
                  About
                </motion.p>
                <motion.p
                  initial={{ y: -30, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.35, type: "spring" }}
                  viewport={{ once: true }}
                  onClick={() => {
                    handleLinkClick();
                    scrollToSection(contact);
                  }}
                >
                  Contact
                </motion.p>
                <motion.a
                  href="https://drive.google.com/file/d/15Z89qb4OSUbcP3KprbP8P-W9tG2U_DmH/view?usp=sharing"
                  target="_blank"
                  rel="noreferrer"
                  initial={{ y: -30, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.4, type: "spring" }}
                  viewport={{ once: true }}
                  onClick={() => {
                    handleLinkClick();
                  }}
                >
                  <p>Resume</p>
                </motion.a>
              </div>
            </div>
          </nav>
        </div>
        <div className="intro">
          <h1>
            <motion.span
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.1, type: "spring" }}
              viewport={{ once: true }}
            >
              Hello.
            </motion.span>{" "}
            <motion.span
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.2, type: "spring" }}
              viewport={{ once: true }}
            >
              I'm
            </motion.span>{" "}
            <motion.span
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.3, type: "spring" }}
              viewport={{ once: true }}
            >
              Joseph.
            </motion.span>
          </h1>
          <motion.p
            initial={{ y: 40, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5, type: "spring" }}
            viewport={{ once: true }}
          >
            I am a Front-end Engineer and Tech Enthusiast.
          </motion.p>
          <motion.p
            initial={{ y: 40, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.6, type: "spring" }}
            viewport={{ once: true }}
          >
            Scroll to see some of my works.
          </motion.p>
        </div>
      </header>
      <section className="works" ref={works}>
        <div>
          <div className="each-work">
            <motion.h2
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.1, type: "spring" }}
              viewport={{ once: true }}
            >
              Scissor
            </motion.h2>
            <div className="clients deezey">
              <motion.a
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ delay: 0.3, type: "spring" }}
                viewport={{ once: true }}
                href="https://scissor-url-shortener.vercel.app/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={scissor} alt="scissor (URL Shortener)" />
              </motion.a>
              <div className="client-info">
                <motion.p
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ delay: 0.4, type: "spring" }}
                  viewport={{ once: true }}
                  style={{ marginBottom: "0.9rem" }}
                >
                  Elevate your online presence with our advanced URL shortening
                  platform. This cutting-edge tool allows users to personalize
                  shortened URLs, aligning them seamlessly with their brand
                  identity.
                </motion.p>
                <motion.div
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ delay: 0.5, type: "spring" }}
                  viewport={{ once: true }}
                  style={{ marginBottom: "1.5rem" }}
                >
                  <p style={{ marginBottom: "0.8rem" }}>
                    Some of the features include
                  </p>
                  <ul>
                    <li>Users are able to shorten a link.</li>
                    <li>Users are able to generate QR codes.</li>
                    <li>Users are able to login and signup for an account.</li>
                  </ul>
                </motion.div>
                <motion.div
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ delay: 0.6, type: "spring" }}
                  viewport={{ once: true }}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <h5>Technologies used</h5>
                  <img src={react} alt="React Js" />
                  <img src={typescript} alt="React Js" />
                  <img src={css} alt="Css3" />
                  <img src={firebase} alt="firebase" />
                </motion.div>
              </div>
            </div>
          </div>
          <div className="each-work">
            <motion.h2
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.1, type: "spring" }}
              viewport={{ once: true }}
            >
              Deezey Media
            </motion.h2>
            <div className="clients deezey">
              <motion.a
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ delay: 0.3, type: "spring" }}
                viewport={{ once: true }}
                href="https://deezeymedia.com"
                target="_blank"
                rel="noreferrer"
              >
                <img src={deezey} alt="deezey media" />
              </motion.a>
              <div className="client-info">
                <motion.p
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ delay: 0.4, type: "spring" }}
                  viewport={{ once: true }}
                >
                  I developed a responsive website for Deezey Media, a versatile
                  media company that creates content for brands and individuals.
                  The goal of the project was to create a user-friendly website
                  that showed the services offered by Deezey Media and to tell a
                  story about the company. I had to ensure the site was
                  responsive across all devices. The website recieved positive
                  feedback from the client.
                </motion.p>
                <motion.div
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ delay: 0.5, type: "spring" }}
                  viewport={{ once: true }}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <h5>Technologies used</h5>
                  <img src={react} alt="React Js" />
                  <img src={css} alt="Css3" />
                  <img src={firebase} alt="firebase" />
                </motion.div>
              </div>
            </div>
          </div>
          <div className="each-work">
            <motion.h2
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.1, type: "spring" }}
              viewport={{ once: true }}
            >
              Enco Finance
            </motion.h2>
            <div className="clients deezey">
              <motion.a
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ delay: 0.3, type: "spring" }}
                viewport={{ once: true }}
                href="https://enco-two.vercel.app/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={enco} alt="enco finance" />
              </motion.a>
              <div className="client-info">
                <motion.p
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ delay: 0.4, type: "spring" }}
                  viewport={{ once: true }}
                >
                  Enco Finance is a one-stop shop when in need of urgent cash,
                  extra income, or other financial services. The goal of this
                  project was to create a responsive and user-friendly website
                  that showed products offered by Enco finance and also tell
                  people about the company. The website recieved positive
                  feedback from the team and client.
                </motion.p>
                <motion.div
                  className="languages-used"
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ delay: 0.5, type: "spring" }}
                  viewport={{ once: true }}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <h5>Technologies used</h5>
                  <img src={react} alt="React Js" />
                  <img src={css} alt="Css3" />
                </motion.div>
              </div>
            </div>
          </div>
          {/* <div className="each-work">
            <motion.h2
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.1, type: 'spring' }}
              viewport={{ once: true }}
            >
              Insure
            </motion.h2>
            <div className="clients deezey">
              <motion.a
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ delay: 0.3, type: 'spring' }}
                viewport={{ once: true }}
                href="https://deezeymedia.com"
                target="_blank"
                rel="noreferrer"
              >
                <img src={deezeydigital} alt="deezey digital" />
              </motion.a>
              <div className="client-info">
                <motion.p
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ delay: 0.4, type: 'spring' }}
                  viewport={{ once: true }}
                >
                  Deezey Media is a versatile media company that creates content
                  for brands and individuals. Lorem ipsum dolor, sit amet
                  consectetur adipisicing elit. Iste deserunt esse nam accusamus
                  illum officia ex totam in, aut nesciunt harum. Ipsum itaque,
                  natus tenetur voluptates dolore minima amet labore.
                </motion.p>
                <motion.div
                  className="languages-used"
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ delay: 0.5, type: 'spring' }}
                  viewport={{ once: true }}
                >
                  <h5>Technologies used</h5>
                  <img src={react} alt="React Js" />
                  <img src={css} alt="Css3" />
                </motion.div>
              </div>
            </div>
          </div> */}
        </div>
      </section>
      <section className="language">
        <div className="tools">
          <h3>Tools I am familiar with</h3>
          <div className="logos">
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
            >
              <img src={javascript} alt="javscript icon" />
            </motion.div>
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.1, type: "spring" }}
              viewport={{ once: true }}
            >
              <img src={react} alt="react icon" />
            </motion.div>
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.2, type: "spring" }}
              viewport={{ once: true }}
            >
              <img src={css} alt="css icon" />
            </motion.div>
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.3, type: "spring" }}
              viewport={{ once: true }}
            >
              <img src={html} alt="html icon" />
            </motion.div>
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.4, type: "spring" }}
              viewport={{ once: true }}
            >
              <img src={vue} alt="vue icon" />
            </motion.div>
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.5, type: "spring" }}
              viewport={{ once: true }}
            >
              <img src={typescript} alt="typescript icon" />
            </motion.div>
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.6, type: "spring" }}
              viewport={{ once: true }}
            >
              <img src={vscode} alt="vscode icon" />
            </motion.div>
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.7, type: "spring" }}
              viewport={{ once: true }}
            >
              <img src={git} alt="git icon" />
            </motion.div>
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.8, type: "spring" }}
              viewport={{ once: true }}
            >
              <img src={github} alt="github icon" />
            </motion.div>
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.9, type: "spring" }}
              viewport={{ once: true }}
            >
              <img src={firebase} alt="firebase icon" />
            </motion.div>
          </div>
        </div>
      </section>
      <section className="about" ref={about}>
        <div>
          <p>
            Hi there! My name is Joseph Okpala, I am a passionate Front-End
            developer who specializes in creating responsive and user-friendly
            websites using modern web technologies. <br /> <br />
            I have a strong eye for design and a deep understanding of Front-End
            development, including HTML, CSS, JavaScript, and popular Front-End
            frameworks such as React. <br /> <br />
            In addition to my technical skills, I am a collaborative team player
            who enjoys working closely with clients to understand their needs
            and deliver solutions that exceed their expectations. I am always
            eager to learn and stay up-to-date with the latest web development
            trends and technologies.
          </p>
          <img src={man} alt="" />
        </div>
      </section>
      <footer ref={contact}>
        <div className="footer">
          <h3>
            <span>Ready to get started?</span>
            <motion.a href="mailto:okpalajoseph995@gmail.com">
              {" "}
              Shoot me a message.
            </motion.a>
          </h3>
          <div>
            <a
              href="https://www.github.com/JosephOkpala"
              target="_blank"
              rel="noreferrer"
            >
              <img src={githubWhite} alt="github logo white" />
            </a>
            <a
              href="https://twitter.com/unorthodox__dev"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              <img src={twitter} alt="twitter logo" />
            </a>
            <a
              href="https://www.linkedin.com/in/joseph-okpala/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={linkedin} alt="linkedin logo" />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;
